/* CUSTOM CODE */

if (window.__brandOkSectionInitialized) {
    /* CUSTOM CODE */
} else {
    window.__brandOkSectionInitialized = true;

document.addEventListener('DOMContentLoaded', function() {
    var sectionRoots = document.querySelectorAll('[data-brand-ok-root]');

    sectionRoots.forEach(function(root) {
        var allBrandsButton = root.querySelector('[data-all-brands]');
        var brandSearchInput = root.querySelector('[data-brand-search]');
        var items = Array.from(root.querySelectorAll('.letter-filter[data-brand-row]'));
        var rows = Array.from(root.querySelectorAll('.flex-item[data-brand-group]'));
        var brandLinks = Array.from(root.querySelectorAll('[data-brand-name]'));
        var classes = ['text-[rgb(var(--colors-text-link))]', 'underline', 'underline-offset-4'];
        var rowLinks = new Map(rows.map(function(row) {
            return [row, Array.from(row.querySelectorAll('[data-brand-name]'))];
        }));

        function setActiveFilter(activeItem) {
            items.forEach(function(item) {
                item.classList.remove.apply(item.classList, classes);
            });

            if (activeItem) {
                activeItem.classList.add.apply(activeItem.classList, classes);
            }
        }

        function showRows(targetRowId) {
            rows.forEach(function(row) {
                var shouldShow = !targetRowId || row.id === targetRowId;
                row.classList.toggle('hidden', !shouldShow);
            });
        }

        if (allBrandsButton) {
            allBrandsButton.addEventListener('click', function() {
                setActiveFilter(null);
                showRows(null);
            });
        }

        items.forEach(function(item) {
            var link = item.querySelector('.link-speciale');
            var targetRowId = item.dataset.brandRow;

            if (!link || !targetRowId) {
                return;
            }

            link.addEventListener('click', function(event) {
                var row;
                var targetPosition;
                var offsetPosition;

                event.preventDefault();
                setActiveFilter(item);
                showRows(targetRowId);

                row = root.querySelector('#' + CSS.escape(targetRowId));
                if (!row) {
                    return;
                }

                row.classList.remove('hidden');
                targetPosition = row.getBoundingClientRect().top + window.scrollY;
                offsetPosition = targetPosition - 100;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            });
        });

        if (brandSearchInput) {
            brandSearchInput.addEventListener('input', function() {
                var inputValue = this.value.trim().toLowerCase();

                brandLinks.forEach(function(link) {
                    var brandName = link.dataset.brandName || '';
                    var isVisible = inputValue.length === 0 || brandName.includes(inputValue);
                    link.classList.toggle('hidden', !isVisible);
                });

                rows.forEach(function(row) {
                    var visibleLinks = rowLinks.get(row) || [];
                    var hasVisibleLink = visibleLinks.some(function(link) {
                        return !link.classList.contains('hidden');
                    });

                    row.classList.toggle('hidden', inputValue.length > 0 && !hasVisibleLink);
                });

                if (inputValue.length > 0) {
                    setActiveFilter(null);
                }
            });
        }
    });
});

}

/* CUSTOM CODE */